import { Component, HostListener } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { HelpersService } from 'src/app/services/helpers.service';
import { ProductsService } from 'src/app/services/products.service';

@Component({
  selector: 'app-workshop-jobcard-create-sku',
  templateUrl: './workshop-jobcard-create-sku.component.html',
  styleUrls: ['./workshop-jobcard-create-sku.component.scss']
})
export class WorkshopJobcardCreateSkuComponent {

  public product: any = {
    taxable: true,
    defaultPrice: '',
    name: '',
  };
  public vatInclusive = false;
  public vatRate = 0.0;
  public editingSKU = false;
  public skuExists = false;
  public saving = false;
  public currencySymbol = '';
  public currencyoptions: any = {
    prefix: '',
  };

  constructor(
    private productsService: ProductsService,
    private helpersService: HelpersService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
    public activeModal: NgbActiveModal
  ) { }

  private modelChanged: Subject<string> = new Subject<string>();
  private subscription: Subscription;
  debounceTime = 250;

  ngOnInit() {
    this.vatInclusive = this.helpersService.getPartnerData().VATInclusive;
    this.vatRate = this.helpersService.getPartnerData().VATRate * 100;
    this.currencySymbol =
      this.helpersService.getPartnerData().CurrencySymbol + ' ';
    this.currencyoptions.prefix = this.currencySymbol;

    this.subscription = this.modelChanged
      .pipe(debounceTime(this.debounceTime))
      .subscribe(() => {
        this.searchProducts();
      });
  }

  inputChanged() {
    this.modelChanged.next('');
  }

  searchProducts() {
    this.productsService
      .checkSKUExists({
        SKU: this.product.sku,
        PartnerID: this.helpersService.getPartnerId(),
        ProductID: this.product.id,
      })
      .subscribe(
        (result) => {
          this.skuExists = true;
        },
        (err) => {
          this.skuExists = false;
        },
      );
  }

  valid() {
    return !!(
      !this.skuExists &&
      this.product.name &&
      this.product.name.length > 0 &&
      this.product.defaultPrice !== null &&
      this.product.defaultPrice.toString().length > 0
    );
  }

  save() {
    if (this.valid()) {
      this.saving = true;
      this.addProduct();
    }
  }

  addProduct() {
    var data = {
      ...this.product,
      partnerID: this.helpersService.getPartnerId(),
    };

    this.productsService.createSingleProduct(data).subscribe(
      (res) => {
        this.saving = false;
        setTimeout(() => {
          this.product = {
            taxable: true,
            defaultPrice: '',
            name: '',
          };
        }, 250);
        this.activeModal.close(res);
      },
      (err) => {
        this.saving = false;
      },
    );
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleEnter(event: KeyboardEvent) {
    this.save();
  }

}
